import { Component, OnInit } from '@angular/core';
import { Meta, Title, DomSanitizer } from '@angular/platform-browser';
import { GlobalConstants } from 'src/app/global-config';
import { ServiceService } from '../../service.service';
import { Router } from '@angular/router';
import { MetaServiceService } from '../../meta-service.service';

@Component({
  selector: 'app-templates',
  templateUrl: './templates.component.html',
  styleUrls: ['./templates.component.scss'],
})
export class TemplatesComponent implements OnInit {
  safeURL; //youTube Video URL //
  // tempData: any; //TempData
  categorylist: any[];
  tempData: any;
  public server = GlobalConstants.apiURL;
  selected_category: any;
  selected_category_name: any;
  cat_name: any;
  tempcont: any;

  constructor(
    private meta: Meta,
    private title: Title,
    private _sanitizer: DomSanitizer,
    public service: ServiceService,
    public router: Router,
    private metaService: MetaServiceService
  ) {
    //  SEO Meta Description
    this.meta.addTags([
      {
        name: 'description',
        content:
          'Explore the professionally pre-designed survey templates for various businesses and industries with the best mobile-based survey application.',
      },
      { name: 'author', content: 'CViewSurvey' },
      { 
        name: 'keywords',
        content: 'Mobile Survey App , Mobile Survey App Design , Pre design survey templates' ,  },
    ]);

    this.setTitle('Pre-designed survey | Mobile Based Survey Application');
    // End SEO Meta Description
    // this.categoryList();
    this.categoryList();
  }

  // SEO Page Title Description
  public setTitle(newTitle: string) {
    this.title.setTitle(newTitle);
  }
  // SEO Page Title Description

  ngOnInit() {
    // for create canonical link 
    this.metaService.createCanonicalURL();
    
    // other
    this.categoryList();
    let category_id = window.localStorage.getItem('category_id');
    let category_name = window.localStorage.getItem('category_name');

    if (category_id != null) {
      this.tempList(category_id, category_name);
    }

    this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(
      'https://www.youtube.com/embed/EsPq62yE3AE'
    );
  }

  categoryList() {
    this.service.getdata().subscribe((data: any[]) => {
      this.categorylist = data;
   
      let category_id = window.localStorage.getItem('category_id');
      if (category_id == '' || category_id == null) {
        this.selected_category = this.categorylist[0].id;
        this.selected_category_name = this.categorylist[0].category_name;
        this.tempList(this.selected_category, this.selected_category_name);
      }
    });
    (error) => {
      console.log('no data found');
    };
  }

  tempList(id, category_name) {
    this.temp_count(id);
    this.service.template_list(id).subscribe((data: any[]) => {
      this.tempData = data['data']['templates'];
      window.localStorage.removeItem('category_id');
    });
    this.cat_name = category_name;
    (error) => {
      console.log('no data found');
    };
  }

  templates_question(selected_temp_id, category_id) {
    window.localStorage.removeItem('category_name');
    window.localStorage.setItem('category_name', this.cat_name);
    window.localStorage.removeItem('selected_temp_id');
    window.localStorage.setItem('selected_temp_id', selected_temp_id);
    window.localStorage.removeItem('category_id');
    window.localStorage.setItem('category_id', category_id);
    this.router.navigate(['/templates-question-details']);
  }

  temp_count(id) {
    this.service.template_count(id).subscribe((data: any[]) => {
      this.tempcont = data['data'];
    });
    //  this.cat_name = category_name;
    (error) => {
      console.log('no data found');
    };
  }
}
